/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { selectLocaleDict } from 'features/locale/selectors'

import { addNotify } from 'components/Notify'
import { Button } from 'components/UIKit/Button/Button'

type CustomButtonProps = {
  text: string
  children: any
  btnProps?: Record<string, any>
}

const CopyButtonHoc: React.FC<CustomButtonProps> = ({ text, children, btnProps }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const onCopy = () => {
    navigator.clipboard.writeText(text)
    addNotify(locale.copied)
  }

  return (
    <Button onClick={onCopy} {...btnProps}>
      {children}
    </Button>
  )
}

export default CopyButtonHoc
